import React, { useState } from 'react';
import { Card, CardBody, Col, Collapse } from 'reactstrap';
import className from 'classnames';

import Icon from '../assets/icons/Icon';

const Panel = (props) => {
    const {
        md,
        lg,
        xl,
        sm,
        xs,
        title,
        children,
        classname,
        colClassName,
        panelClassName,
        collapsable = false,
    } = props;
    const [isOpen, setIsOpen] = useState(false);

    const toggleCollapse = () => {
        if (collapsable) {
            setIsOpen((prev) => !prev);
        }
    };

    const titleClassName = className({
        'm-0': !isOpen,
    });

    return (
        <Col md={md} lg={lg} xl={xl} sm={sm} xs={xs} className={colClassName}>
            <Card className={`panel ${panelClassName}`}>
                <CardBody className={`panel__body ${classname}`}>
                    {title && (
                        <div
                            className={`panel__title ${titleClassName} d-flex justify-content-between align-items-center`}
                            onClick={toggleCollapse}
                            onKeyDown={toggleCollapse}
                            aria-hidden
                        >
                            <h5 className="bold-text mb-0">{title}</h5>
                            {collapsable && (
                                <Icon
                                    icon={isOpen ? 'ChevronUp' : 'ChevronDown'}
                                    width={24}
                                />
                            )}
                        </div>
                    )}
                    <Collapse isOpen={isOpen || !collapsable}>
                        <div className="panel__content">{children}</div>
                    </Collapse>
                </CardBody>
            </Card>
        </Col>
    );
};

Panel.defaultProps = {
    title: '',
    md: 0,
    lg: 0,
    xl: 0,
    sm: 0,
    xs: 0,
    classname: '',
    colClassName: '',
};

export default Panel;
